import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from 'components/ui/BrandLogo';
import { Cta, Heading, Reveal, Section } from './primitives';

export function FunnelHeader({ variant }) {
  return (
    <header
      className="fixed inset-x-0 top-0 z-40 border-b border-white/5 bg-[#0A0A0A]/70 backdrop-blur-xl"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4">
        <BrandLogo />
        <Cta variant={variant} className="!min-h-[38px] !py-2 !px-4 !text-xs !animate-none">Start</Cta>
      </div>
    </header>
  );
}

export function FinalClose({ variant }) {
  return (
    <Section className="text-center">
      <Reveal>
        <Heading
          lines={['Your mind is going to talk to you tomorrow anyway.', 'What do you want it practicing?']}
          className="text-3xl md:text-5xl"
        />
        <p className="mt-8 text-sm uppercase tracking-[0.2em] text-white/30">
          If you don't train your mind, your mind will train you.
        </p>
        <div className="mt-10">
          <Cta variant={variant}>Try DepthMe now</Cta>
        </div>
        <p className="mt-4 font-jakarta text-lg italic text-white/60">Your inner voice, upgraded.</p>
        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/50">
          {['Personalized', 'AI-powered', 'Your own voice', 'Start in minutes'].map((t) => (
            <li key={t}>✓ {t}</li>
          ))}
        </ul>
      </Reveal>
    </Section>
  );
}

export function FunnelFooter() {
  return (
    <footer className="border-t border-white/5 px-4 pb-28 pt-10 md:pb-10">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-4 text-xs text-white/40 sm:flex-row">
        <BrandLogo size={24} />
        <p>
          © {new Date().getFullYear()} DepthMe ·{' '}
          <Link to="/privacy" className="hover:text-white">Privacy</Link> ·{' '}
          <Link to="/terms" className="hover:text-white">Terms</Link>
        </p>
      </div>
    </footer>
  );
}

// Mobile-only bar; appears once the hero CTA has scrolled away so it never
// covers the first screen (the overlap fixed in 26a4e13).
export function StickyCta({ variant }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0A0A0A]/85 px-4 pt-3 backdrop-blur-xl transition-transform duration-300 md:hidden ${show ? 'translate-y-0' : 'translate-y-full'}`}
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 12px)' }}
      aria-hidden={!show}
    >
      <p className="mb-2 text-center text-[11px] text-white/50">Join thousands training their inner voice</p>
      <Cta variant={variant} className="w-full" />
    </div>
  );
}
